import { render, staticRenderFns } from "./ShowShopList.vue?vue&type=template&id=4d45bc0a&scoped=true&"
import script from "./ShowShopList.vue?vue&type=script&lang=js&"
export * from "./ShowShopList.vue?vue&type=script&lang=js&"
import style0 from "./ShowShopList.vue?vue&type=style&index=0&id=4d45bc0a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d45bc0a",
  null
  
)

export default component.exports